const SLCommon = Mach.requireModule('SLCommon');
const Router = Mach.requireModule('Router');

const { env } = SLCommon.getEnv();

const interCodeUrl = env === 'Test'
  ? 'http://passport-i18n.fe.test.sankuai.com/i/change-phonenumber'
  : 'https://passport.mykeeta.com/i/change-phonenumber';

const toBindPhone = () => {
  Router.navigateTo(interCodeUrl);
};

export { toBindPhone };
